import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';

const Image = ({ src, alt, classes, ...props }) => {
  const isGif = props?.format === 'gif';

  if (!src) return null;

  if (typeof src === 'object' && !isGif) {
    return (
      <GatsbyImage
        className={`gatsby-image ${classes || 'UpKeep'}`}
        image={src}
        alt={alt || ''}
        width={props?.width}
        height={props?.height}
        loading={props?.loading || 'lazy'}
        imgStyle={props?.imgStyles}
        objectFit={props?.objectFit}
        objectPosition={props?.objectPosition}
      />
    );
  }

  const gifUrl = props?.fallbackUrl?.replace(/\?.*$/, '');

  return (
    <img
      className={`responsive-img ${classes || 'UpKeep'}`}
      src={isGif ? gifUrl : src}
      alt={alt || ''}
      style={props?.imgStyles}
      width={props?.width}
      height={props?.height}
      loading={props?.loading || 'lazy'}
    />
  );
};

export default Image;
